<script>
export default {
    inheritAttrs: false,
}
</script>

<script setup>
import { computed, useAttrs } from 'vue';
import { twMerge } from 'tailwind-merge';

const props = defineProps({ 
    name: { type: String, required: true },
    size: { type: String, default: 'sm', validator: value => ['sm', 'lg', 'xl'].includes(value) }
});

const { class: cssClass, ...attrs } = useAttrs();

const letters = computed(() => {
        return props.name.slice(0, 1);
});


const colors = computed(() => {
    const offset = 'a'.charCodeAt(0);
    const name = letters.value.toLowerCase();
    const score = name.charCodeAt(0) - offset;

    if (score <= 4) {
        return { bg: 'bg-gradient-to-br from-sky-100/50 to-sky-100/45', text: 'text-sky-600' }
    }

    if (score <= 8) {
        return { bg: 'bg-gradient-to-br from-orange-100/50 to-orange-100/45', text: 'text-orange-600' }
    }

    if (score <= 12) {
        return { bg: 'bg-gradient-to-br from-red-100/50 to-red-100/45', text: 'text-red-600' }
    }

    if (score <= 16) {
        return { bg: 'bg-gradient-to-br from-blue-100/50 to-blue-100/45', text: 'text-blue-600' }
    }

    if (score <= 20) {
        return { bg: 'bg-gradient-to-br from-teal-100/50 bg-teal-100/45', text: 'text-teal-600' }
    }

    return { bg: 'bg-gradient-to-br from-primary/40 to-primary-35', text: 'text-primary' }
});

const width = computed(() => {
    const map = {
        'sm': 'w-9',
        'md': 'w-14',
        'lg': 'w-24',
        'xl': 'w-32',
    }

    return map[props.size] ?? 'w-9';
});
</script>

<template>
    <!-- TODO: twMerge to change sizes -->
    <!-- TODO2: auto color generation based on letters -->
    <div 
        :class="twMerge(width, 'avatar-textual', 'aspect-square', 'rounded-full', 'flex', 'items-center', 'justify-center', colors.bg, cssClass)"
        v-bind="attrs"
    >
        <div class="uppercase font-bold" :class="{[colors.text]: true, 'text-xl': size === 'sm', 'text-2xl': size === 'lg', 'text-3xl': size === 'xl' }">{{ letters }}</div>
    </div>
</template>
